import React, { useContext, useState } from "react";
import './PopupWithDropdown.css';
import { ProfileContext } from "../../../context/ProfileContext";
import PopupWindow from "../../UI-comp/PopupWindow";
import CommonDropdown from "../../UI-comp/CommonDropdown";
import useProfileDeletion from "../../../hooks/useProfileDeletion"; // Custom hook for deletion
import { generateProfileOptionsForDelete } from "../../../utils/profileUtils"; // Utility function
import { color } from "framer-motion";

const PopupWithDropdown = ({ isOpen, onClose }) => {
  const [selectedProfile, setSelectedProfileState] = useState(""); // Default to ""
  const { profiles } = useContext(ProfileContext);
  const { handleProfileDeletion } = useProfileDeletion();

  // Generate options for the dropdown (without the placeholder)
  const profileOptions = generateProfileOptionsForDelete(profiles); // Expecting an array of objects

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedProfile) {
      alert("Please select a profile to delete.");
      return;
    }
    handleProfileDeletion(selectedProfile);
    onClose(); // Close the popup after deletion
    setSelectedProfileState(""); // Reset the selected profile to default
  };

  const handleCancel = (e) => {
    onClose(); // Close the popup after deletion  
  }

  return (
    <PopupWindow className="Popup-window" isOpen={isOpen} onClose={onClose}>
      <h2 className="ua-Popup-window-h2"> Delete Profile</h2>
      <form onSubmit={handleSubmit}>
        <CommonDropdown
          options={profileOptions} // Only the actual profile options
          value={selectedProfile}
          onChange={(value) => setSelectedProfileState(value)} // Update the selected profile
          placeholder="--Select Profile--" // The placeholder will be displayed when nothing is selected
          style={{ marginBottom: '15px', color: "black" }} // Inline style to add gap
        />
        <button type="cancel" className="uap-submit-button" onClick={() => handleCancel()}>
          Cancel
        </button>
        <button type="submit" className="uap-submit-button">
          Delete
        </button>
      </form>
    </PopupWindow>
  );
};

export default PopupWithDropdown;
